"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var type_1 = require("./type");
var initialState = {
    user: undefined
};
function authenticationReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case type_1.STORED_AUTH_USER: {
            return __assign(__assign({}, state), { user: action.payload });
        }
        default:
            return state;
    }
}
exports.authenticationReducer = authenticationReducer;
//# sourceMappingURL=reducer.js.map